import type { FilterField } from '@/shared/components/filter/types'
import type { FilterSchema } from '@/shared/components/filter/validation'
import type { Placement } from '@floating-ui/react-dom'

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getPricingTypeChoices } from '@/entities/assortment'
import { createChoices, toAdaptedSchema } from '@/entities/column'

import { useAiDashboardFilterFieldsConfig } from '../../lib/useAiDashboardFilterFieldsConfig'
import BaseFilter from '../Filter/BaseFilter'

type Props = {
	filters: FilterSchema[]
	onChange(filters: FilterSchema[]): void
	placement?: Placement
	fields?: FilterField[]
	irremovableCount?: number
}

export default function AiDashboardFilter(props: Props) {
	const { t } = useTranslation()
	const { choices, schema } = useAiDashboardFilterFieldsConfig()
	const fields = useMemo(
		() => schema?.map((schema) => toAdaptedSchema(schema, t)) || [],
		[schema, t]
	)
	const options = useMemo(
		() => ({
			pricing_type: getPricingTypeChoices(t),
			...createChoices({
				entities: choices,
				schema: schema || [],
			}),
		}),
		[choices, schema, t]
	)

	return (
		<BaseFilter
			{...props}
			onChange={(filters) => {
				props.onChange(
					filters.slice(props.irremovableCount || 0, filters.length)
				)
			}}
			fields={fields}
			options={options}
		/>
	)
}
